import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconUngroup = () => {
  return (
    <g>
      <path
        d="m1.05 0 13.901.017c.541 0 .986.41 1.043.936l.006.114V14.95c0 .541-.41.987-.936 1.044L14.95 16H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V1.05C0 .51.41.064.936.007L1.05 0zm6.2 8.75H1.5v5.75h5.75V8.75zm7.25 0H8.75v5.75h5.75V8.75zM1.5 1.5v5.748h5.75V1.507L1.5 1.501zm7.25.007V7.25h5.75V1.516l-5.75-.008z"
        
      />
    </g>
  );
};


export default withIcon(IconUngroup);
